var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"library-icon"},[_c('img',{attrs:{"src":("https://icon-widget.codersrank.io/api/" + (encodeURIComponent(_vm.name))),"alt":_vm.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }